
import { RevLink } from '@ds/components/Link'
import { IconHome } from '@ds/icons/IconHome'
import { IconStarOutlined } from '@ds/icons/IconStarOutlined'
import get from 'lodash/get'
import { mapGetters } from 'vuex'

import { MAX_RATING } from '@reviews/constants'

import translations from './Performances.translations'

export default {
  components: {
    RevLink,
    IconStarOutlined,
    IconHome,
  },
  props: {
    age: {
      type: Number,
      required: true,
    },
    reviewsUrl: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    MAX_RATING: () => MAX_RATING,
    translations: () => translations,

    ...mapGetters({
      sellerRate: 'landing/ratings',
    }),

    sellerSince() {
      const years = this.$t
        .relativeDate()
        .formatToParts(Math.floor(this.age / 12), 'year')
      const months = this.$t
        .relativeDate()
        .formatToParts(this.age % 12, 'month')

      const formattedYear =
        years[1].value > 0 ? `${years[1].value}${years[2].value}` : ''
      const formattedMonths =
        months[1].value > 0 ? `${months[1].value}${months[2].value}` : ''

      return [formattedYear, formattedMonths].filter((val) => !!val).join(' ')
    },

    hasReviews() {
      return get(this.sellerRate, 'reviewsCount', 0) > 0
    },

    averageRatings() {
      return get(this.sellerRate, 'averageRate', 0)
    },

    ratingsLabel() {
      return this.$t(this.translations.reviewLink, {
        rank: this.averageRatings,
        maxRating: MAX_RATING,
      })
    },
  },
}
